import AxiosAPI from "./AxiosAPI";
import axios from "axios";
// export const fetchProducts = async () => {
//   try {
//     const response = await AxiosAPI.get(
//       `catalog/products?isDeleted=false&size=10`
//     );
//     return response;
//   } catch (error) {
//     throw error.response?.data || error;
//   }
// };

export const fetchProducts = async (
  searchParam = null,
  from = 0,
  size = 10,
  productType,
  name,
  sku,
  barCode,
  category,
  subCategory,
  brand,
  status,
  storeID,
  psin,
  globalCatalogue,
  excludeChildProduct,
  storeSpecificPrices
) => {
  try {
    let apiUrl = `catalog/products`;
    let queryParams = [];

    // Always include isDeleted=false if status is not provided
  if (!status) { 

    queryParams.push(`isDeleted=${encodeURIComponent(false)}`);
  }

    // Pagination and tracking parameters
    queryParams.push(`size=${encodeURIComponent(Number(size))}`);
    queryParams.push(`from=${encodeURIComponent(Number(from))}`);

    // Optional store-specific prices
    if (storeSpecificPrices) {
      queryParams.push(`storeSpecificPrices=${encodeURIComponent(storeSpecificPrices)}`);
    }

    // Optional search-related parameters
    if (psin) {
      queryParams.push(`psin=${encodeURIComponent(psin)}`);
    }
    if (globalCatalogue) {
      queryParams.push(`globalCatalogue=${encodeURIComponent(globalCatalogue)}`);
    }
    if (excludeChildProduct) {
      queryParams.push(`excludeChildProduct=${encodeURIComponent(excludeChildProduct)}`);
    }
    if (searchParam) {
      queryParams.push(`searchParam=${encodeURIComponent(searchParam)}`);
    }
    if (productType) {
      queryParams.push(`productType=${encodeURIComponent(productType)}`);
    }
    if (name) {
      queryParams.push(`name=${encodeURIComponent(name)}`);
    }
    if (sku) {
      queryParams.push(`sku=${encodeURIComponent(sku)}`);
    }
    if (barCode) {
      queryParams.push(`barCode=${encodeURIComponent(barCode)}`);
    }
    if (category) {
      queryParams.push(`category=${encodeURIComponent(category)}`);
    }
    if (subCategory) {
      queryParams.push(`subCategory=${encodeURIComponent(subCategory)}`);
    }
    if (brand) {
      queryParams.push(`brand=${encodeURIComponent(brand)}`);
    }

    // Status parameter if not "all"
  if (status !== "all") { queryParams.push(status)}

    // Store ID if provided
    if (storeID !== "" && storeID !== undefined) {
      queryParams.push(`storeID=${encodeURIComponent(storeID)}`);
    }

    // Build final URL
    apiUrl += `?${queryParams.join("&")}`;

    console.log("Fetching URL:", apiUrl);
    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error.response?.data || error;
  }
};



export const fetchProductsForExport = async (
  searchParam = null,
  from = 0,
  size = 10,
  productType,
  name,
  sku,
  barCode,
  category,
  subCategory,
  brand,
  status,
  storeID,
  psin,
  globalCatalogue,
  excludeChildProduct=true,
    pitId = null,
  searchAfter = null,
  storeSpecificPrices
) => {
 try {
  let apiUrl = `/catalogexport`;
  let queryParams = [];

  if (!status) {
    queryParams.push(`isDeleted=false`);
  }

  const hasSearchParams =
    searchParam || productType || name || sku ||
    barCode || category || subCategory || brand;

  queryParams.push(`size=${encodeURIComponent(size)}`);
  queryParams.push(`from=${encodeURIComponent(from)}`);

  if (storeSpecificPrices) {
    queryParams.push(`storeSpecificPrices=${encodeURIComponent(storeSpecificPrices)}`);
  }

  if (psin) {
    queryParams.push(`psin=${encodeURIComponent(psin)}`);
  }

  if (pitId) {
    queryParams.push(`pitId=${encodeURIComponent(pitId)}`);
  }

  if (searchAfter) {
    queryParams.push(`searchAfter=${encodeURIComponent(searchAfter)}`);
  }

  if (globalCatalogue) {
    queryParams.push(`globalCatalogue=${encodeURIComponent(globalCatalogue)}`);
  }

  queryParams.push(`excludeChildProduct=${encodeURIComponent(excludeChildProduct)}`);

  if (searchParam) {
    queryParams.push(`searchParam=${encodeURIComponent(searchParam)}`);
  }

  if (productType) {
    queryParams.push(`productType=${encodeURIComponent(productType)}`);
  }

  if (name) {
    queryParams.push(`name=${encodeURIComponent(name)}`);
  }

  if (sku) {
    queryParams.push(`sku=${encodeURIComponent(sku)}`);
  }

  if (barCode) {
    queryParams.push(`barCode=${encodeURIComponent(barCode)}`);
  }

  if (category) {
    queryParams.push(`category=${encodeURIComponent(category)}`);
  }

  if (subCategory) {
    queryParams.push(`subCategory=${encodeURIComponent(subCategory)}`);
  }

  if (brand) {
    queryParams.push(`brand=${encodeURIComponent(brand)}`);
  }

  if (status !== "all") {
    queryParams.push(status);
  }

  if (storeID !== "" && storeID !== undefined) {
    queryParams.push(`storeID=${encodeURIComponent(storeID)}`);
  }

  apiUrl += `?${queryParams.join("&")}`;

  console.log("Fetching URL:", apiUrl);
  const response = await AxiosAPI.get(apiUrl);
  return response.data;
}
catch (error) {
    console.error("Error fetching product data:", error);
    throw error.response?.data || error;
  }
};

export const fetchChildProducts = async (productID,storeID) => {
  try {
    const response = await AxiosAPI.get(`/catalog/products/getchildproduct?productID=${productID}&storeID=${storeID}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchPincodeProducts = async (
  from,
  size,
  storeid,
  searchText,
  category,
  brand,
  outOfStockManual = false,
  outOfStockCancellation = false
) => {
  try {
    let apiUrl = `/catalog/pincodeproducts`;
    let queryParams = [];




    // Add search-related parameters if they exist

    if (from) {
      queryParams.push(`from=${from}`);
    }
    if (size) {
      queryParams.push(`size=${size}`);
    }
    if (storeid) {
      queryParams.push(`storeid=${storeid}`);
    }
    if (searchText) {
      queryParams.push(`searchText=${searchText}`);
    }
    if (category) {
      queryParams.push(`category=${category}`);
    }
    if (brand) {
      queryParams.push(`brand=${brand}`);
    }
    if (outOfStockManual) {
      queryParams.push(`outOfStockManual=${outOfStockManual}`);
    }
    if (outOfStockCancellation) {
      queryParams.push(`outOfStockCancellation=${outOfStockCancellation}`);
    }


    apiUrl += `?${queryParams.join("&")}`;

    console.log("Fetching URL:", apiUrl);
    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    throw error.response?.data || error;
  }
};



export const fetchSingleProductApi = async (id) => {
  try {
    const response = await AxiosAPI.get(`/catalog/products/${id}`);
    console.log("Product data:", response.data.product);
    const product = response?.data?.product || {};

// Check if key exists and is not empty
if (!product?.key || product?.key.trim() === "") {
  product.key = id;
}

return product;
  } catch (err) {
    console.error("API Error:", err);
    throw err.response?.data || err;
  }
};






export const handleAddProduct = async (data) => {
  console.log("Payload to add product:", data);

  try {
    const response = await AxiosAPI.post("/catalog/products", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add product:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};


export const handleAddVariants = async (data, key) => {
  console.log("productapi key", key);

  try {
    const response = await AxiosAPI.post(
      `/catalog/products/variants/${key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const deleteProductDataApi = async (key) => {
  try {
    const response = await AxiosAPI.delete(
      `/catalog/products/${key} `
    );
    return response.data;
  } catch (err) {
    console.log(err);

  }
};

export const handleEditProduct = async (data, key) => {
  console.log("productapi key", key);

  try {
    const response = await AxiosAPI.put(
      `/catalog/products/${key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};



export const fetchBatchProductsData = async (storeLocationID, productID,showAllBatches) => {
  console.log(storeLocationID, productID);

  try {
    const response = await AxiosAPI.get(`/transaction/inventory/batches?storeLocationID=${storeLocationID}&productID=${productID}&allBatches=${showAllBatches}`)
    console.log(response);

    return response.data;
  } catch (err) {
    throw err.response?.data || err
  }
}


export const fetchBatchAuditTrail = async (key) => {

  try {
    const BASE_URL= "https://backend-o3dyulj4pa-el.a.run.app/v2";
    // const response = await AxiosAPI.get(`/catalog/products/audittrail?key=${key}`)
    const response = await axios.get(`${BASE_URL}/catalog/products/audit-trail?key=${key}`)
    console.log(response);

    return response.data;
  } catch (err) {
    throw err.response?.data || err
  }
}


// /transaction/inventory/batches?storeLocationID=L3sNpgZc2UL3DOYTvYxv&productID=SkVYt83sdCCDNNAQNHll

// XLsYkXuockLZEWAivWqz

// /transaction/inventory/uniqueno?storeID=XLsYkXuockLZEWAivWqz&from=0&size=1000&productID=maOjGT1NxCUG7oobhFik

// export const fetchUniqueProductsData = async (storeID, productID) => {
//   try {
//     const response = await AxiosAPI.get(`/transaction/inventory/uniqueno?storeID=${storeID}&from=0&size=1000&productID=${productID}`)
//     return response.data;
//   } catch (err) {
//     throw err.response?.data || err
//   }
// }

export const fetchUniqueProductsData = async (storeID, productID, searchText = '') => {
  try {
    // Build query parameters dynamically
    const params = new URLSearchParams({
      storeID,
      from: 0,
      size: 1000,
    });

    if (productID) {
      params.append('productID', productID);
    }

    if (searchText.trim()) {
      params.append('searchText', searchText.trim());
    }

    const response = await AxiosAPI.get(`/transaction/inventory/uniqueno?${params.toString()}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};
//recordFrom, 1000, props.user.store.key, props.product.key, state.searchText

export const getUniqueListForSalesReturn = async (from=0,size=1000,storeID, productID, searchText = '') => {
  try {
    // Build query parameters dynamically
    const params = new URLSearchParams({
      storeID,
      from,
      size
    });

    if (productID) {
      params.append('productID', productID);
    }

    if (searchText.trim()) {
      params.append('searchText', searchText.trim());
    }

    const response = await AxiosAPI.get(`/transaction/inventory/outwarduniqueno?${params.toString()}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const updateInStockQty = async (id, uniqueNoList) => {
  try {
    const response = await AxiosAPI.put('/inventory/update-stock-qty', {
      id,
      uniqueNoList,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};


export const getParentproduct = async (parentProductID) => {
  try {
    const response = await AxiosAPI.get(`/catalog/parent/${parentProductID}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const fetchProductsForPOSearch = async (storeID,skuArray,excludeUniqueNo) => {
  try {
    const response = await AxiosAPI.get(`/catalog/products/getProductsForPOSearch?storeID=${storeID}&skuArray=${skuArray}&excludeUniqueNo=${excludeUniqueNo}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};
export const fetchProductsBySKUs = async (skus, storeID) => {
  try {

    const encodedSkus = encodeURIComponent(
      Array.isArray(skus) ? skus.join(",") : skus
    );

    const response = await AxiosAPI.get(
      `/catalog/products/getproductbyskus?storeID=${storeID}&skus=${encodedSkus}`
    );

    return response.data;

  } catch (err) {
    throw err.response?.data || err;
  }
};
export const checkSkusAlreadyExist = async (variants) => {
  try {
    const response = await AxiosAPI.post(`/catalog/checkskuisexist`,{variants:variants});
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};




